module.exports = __webpack_public_path__ + "img/open-book-b-active.e8568eab.svg";